class Stepper {
  constructor() {
    this.selectors = {
      wrapper: '.js-stepper',
      item: '.js-stepper-item',
      itemContent: '.js-stepper-content-item',
      first: '.js-stepper-item:first-child',
      last: '.js-stepper-item:last-child',
      active: '.is-active',
      activeContent: '.is-active-content',
    };

    this.classes = {
      active: 'is-active',
      activeContent: 'is-active-content',
    };

    this.controls = {
      currentScroll: window.scrollY,
      freezeScroll: false,
    };

    this.settings = {
      normalizeDelta: 40,
      timeout: 100,
      timeoutLock: 500,
      scrollOffset: -70,
    };

    this.wait = null;

    window.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  getDOM() {
    this.DOM = {
      items: document.querySelectorAll(this.selectors.item),
      itemsContents: document.querySelectorAll(this.selectors.itemContent),
      first: document.querySelector(this.selectors.first),
      last: document.querySelector(this.selectors.last),
      wrapper: document.querySelector(this.selectors.wrapper),
    };
  }

  init() {
    this.getDOM();
    this.bindToggle();
    this.scrollHijacker();
  }

  bindToggle() {
    this.DOM.items.forEach((item) => {
      const itemLink = item.querySelector('a');
      itemLink.addEventListener('click', (ev) => {
        ev.preventDefault();
        this.resetActive();
        item.classList.add(this.classes.active);
        this.resetActiveContent();
        const itemContent = document.querySelector(itemLink.hash);
        itemContent.classList.add(this.classes.activeContent);
      });
    });
  }

  scrollHijacker() {
    if (this.DOM.wrapper) {
      let isHover = false;
      this.DOM.wrapper.addEventListener(
        'mouseenter',
        (event) => {
          event.stopImmediatePropagation();
          isHover = true;
          this.controls.freezeScroll = true;
        },
        false,
      );
      this.DOM.wrapper.addEventListener(
        'mouseleave',
        () => {
          isHover = false;
          this.controls.freezeScroll = false;
        },
        false,
      );

      window.addEventListener('scroll', this.controlScroll.bind(this), false);

      document.addEventListener(
        'wheel',
        () => {
          if (isHover) {
            this.scrollItem();
          }
        },
        false,
      );
    }
  }

  controlScroll() {
    const isFirst = !!this.DOM.first.classList.contains(this.classes.active);
    const isLast = !!this.DOM.last.classList.contains(this.classes.active);
    if (this.controls.freezeScroll && !(isFirst || isLast)) {
      this.setScroll(this.DOM.wrapper.offsetTop - this.settings.scrollOffset);
    }
    this.controls.currentScroll = this.controls.freezeScroll
      ? this.controls.currentScroll
      : window.scrollY;
  }

  setScroll(scrollTop, mode = 'auto') {
    window.scroll({
      top: scrollTop,
      behavior: mode,
    });
    this.controls.currentScroll = scrollTop;

    let lockNavEvent = new CustomEvent('lockNav', {
      detail: { isLocked: 1 },
    });
    document.body.dispatchEvent(lockNavEvent);

    if (this.wait) window.clearTimeout(this.wait);
    this.wait = setTimeout(() => {
      lockNavEvent = new CustomEvent('lockNav', {
        detail: { isLocked: 0 },
      });
      document.body.dispatchEvent(lockNavEvent);
    }, this.settings.timeoutLock);
  }

  scrollItem() {
    const { event } = window;
    const delta = event.detail
      ? event.detail * (this.settings.normalizeDelta * -1)
      : event.wheelDelta;
    const currentItem = this.DOM.wrapper.querySelector(this.selectors.active);
    const currentItemContent = this.DOM.wrapper.querySelector(
      this.selectors.activeContent,
    );
    const prevItem = currentItem.previousSibling.previousElementSibling;
    const prevItemContent =
      currentItemContent.previousSibling.previousElementSibling;
    const nextItem = currentItem.nextSibling.nextElementSibling;
    const nextItemContent = currentItemContent.nextSibling.nextElementSibling;
    setTimeout(() => {
      if (delta < 0) {
        if (nextItem && nextItemContent) {
          this.resetActive();
          nextItem.classList.add(this.classes.active);
          this.resetActiveContent();
          nextItemContent.classList.add(this.classes.activeContent);
        }
      } else if (prevItem && prevItemContent) {
        this.resetActive();
        prevItem.classList.add(this.classes.active);
        this.resetActiveContent();
        prevItemContent.classList.add(this.classes.activeContent);
      }
    }, this.settings.timeout);
  }

  resetActive() {
    this.DOM.items.forEach((item) => {
      item.classList.remove(this.classes.active);
    });
  }

  resetActiveContent() {
    this.DOM.itemsContents.forEach((item) => {
      item.classList.remove(this.classes.activeContent);
    });
  }
}

export default new Stepper();
